module.exports = __webpack_public_path__ + "f6ab6e1c9e90f5699de02909d96bc47a.png";